import { Injectable, inject } from '@angular/core';

import { DeliveryService, Oauth2Service } from '@bytel/checkout';

import { AddressService } from '@services/address.service';
import DELIVERY_MOCKS from '@services/delivery/mock';
import { MainCartService } from '@services/main-cart.service';

import { tunnelRoutes } from '@tunnel/routes';

import { Observable, of } from 'rxjs';

import { StepMock } from '../../../interfaces/mock.interface';
import { Step } from './step';

@Injectable({
    providedIn: 'root',
})
export class DeliveryStep extends Step {
    public static readonly key: string = 'delivery';
    public routerLink: string = `/tunnel/${tunnelRoutes.delivery}`;
    public isValid: boolean;
    public shortLabel: string = 'Livraison';
    public label: string = 'Adresse de livraison et de facturation';
    public next: Step;
    public hasReminder = true;
    public icon: string = 'tri-marker';
    public stepMocks: StepMock[] = DELIVERY_MOCKS;

    protected oauth2Service = inject(Oauth2Service);
    protected addressService = inject(AddressService);
    protected cartService = inject(MainCartService);
    protected deliveryService = inject(DeliveryService);

    constructor() {
        super();
        this.oauth2Service.updateIsConnected();
        this._isLoaded.next(true);
    }

    public canAccess(): Observable<boolean> {
        return of(
            this.oauth2Service.isConnected &&
                !!this.cartService.cartModel.cartId &&
                this.cartService.isAppointmentValid(),
        );
    }

    public canDisplay(): boolean {
        return true;
    }
}
